﻿export class Gender {
    Id: number;
    Name: string;

    constructor() {
        this.Id = -1;
        this.Name = "--Select Gender--";
    }
}
